import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";

export interface UglUser {
  user_id: string;
  first_name?: string;
  last_name?: string;
  full_name?: string;
}

export interface Ugl {
  ugl_id: number;
  user_id: string;
  title: string;
  name: string;
  ugl_hash: string;
  temp_flow_id: number | null;
  chat_branding_id: string | null;
  is_active: boolean;
  is_expiry: boolean;
  expiry_date: string | null;
  added_on?: string;
  updated_on?: string;
  user?: UglUser;
}

export interface UpdateUglDto {
  temp_flow_id?: number | null;
  chat_branding_id?: string | null;
}

export const uglApi = createApi({
  reducerPath: "uglApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Ugl"],
  endpoints: (builder) => ({
    getUglsByOrganization: builder.query<Ugl[], string>({
      query: (organizationId) => ({
        url: `ugl/organization/${organizationId}`,
        method: "GET",
      }),
      transformResponse: (response: unknown) => {
        if (Array.isArray(response)) return response;
        const r = response as { data?: Ugl[] };
        return r?.data ?? [];
      },
      providesTags: (_result, _error, organizationId) => [
        { type: "Ugl", id: `org-${organizationId}` },
      ],
    }),

    updateUgl: builder.mutation<
      unknown,
      { id: number; organizationId: string; data: UpdateUglDto }
    >({
      query: ({ id, organizationId, data }) => ({
        url: `ugl/${id}`,
        method: "PATCH",
        data: { ...data, organizationId },
      }),
      invalidatesTags: (_result, _error, { organizationId }) => [
        { type: "Ugl", id: `org-${organizationId}` },
      ],
    }),
  }),
});

export const {
  useGetUglsByOrganizationQuery,
  useUpdateUglMutation,
} = uglApi;
